import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { withRma } from "MODULES/RMAsAndWarranties/decorators";
import pojo from "LIB/pojos";
import { getValues } from "LIB/maps";
import Section from "MODULES/shared/components/Section";
import { ShippingAddressTable } from "MODULES/shared/components/ShippingAddressTable";
import renderIf from "MODULES/shared/decorators/renderIf";
import {
  SHIP_TO_ADDRESS_PHONE,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIP_TO_CUSTOMER_ADDRESS_ID,
  SHIP_TO_SHIPPING_ADDRESS,
  SHIP_TO_SHIPPING_METHOD,
  SHIP_TO_TYPE
} from "APP_ROOT/constants";
import Form from "./Form";

function ShipTo(props) {
  const { rma } = props;

  const initialValues = pojo(rma.toJS()).pick(
    SHIP_TO_ADDRESS_PHONE,
    SHIP_TO_TYPE,
    SHIP_TO_COMPANY_ID,
    SHIP_TO_COMPANY_ADDRESS_ID,
    SHIP_TO_CUSTOMER_ADDRESS_ID,
    SHIP_TO_SHIPPING_ADDRESS,
    SHIP_TO_SHIPPING_METHOD
  );

  const renderForm = close => (
    <Form close={close} rma={rma.toJS()} initialValues={initialValues} />
  );

  const fob =
    rma.get("ship_to_address") &&
    getValues(rma.get("ship_to_address"), "city", "state", "country").join("-");

  return (
    <Section
      title="Ship To"
      modal={{
        title: "Edit RMA - Ship To",
        content: renderForm
      }}
      editable
      forceOpen={props.forceOpen}
      setForceOpen={props.setForceOpen}
    >
      <ShippingAddressTable
        fob={fob}
        address={rma.get("ship_to_address")}
        shippingMethod={rma.get("ship_to_shipping_method")}
      />
    </Section>
  );
}

ShipTo.propTypes = {
  rma: T.instanceOf(Map).isRequired
};

const hasVendorRmaNumber = renderIf(
  ({ rma }) => (rma.get("vendor_rma_number") || "") !== ""
);

export default withRma(hasVendorRmaNumber(ShipTo));



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/ShipTo/ShipTo.jsx